import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PolicyService} from '../../../../../policy/services/policy.service';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {CalcPremDiffCollation, Collation, Policy, PolicyBenefitsAdded} from '../../../../models/policy.model';
import {GlobalQuestionService} from '../../../../services/global-question.service';
import {EntryType} from '../../../../constants';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { Alert } from 'src/app/modules/shared/utilities';

declare var $: any;
declare var accounting: any;
declare function initModalHandler(): any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

enum CancelDateSelection {
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  EndOfMonth = 'EndOfMonth',
  SpecifiedDate = 'SpecifiedDate'
}

@Component({
    selector: 'app-cancel-policy',
    templateUrl: './cancel-policy.component.html',
    styleUrls: ['./cancel-policy.component.scss'],
    standalone: false
})
export class CancelPolicyComponent implements OnInit, OnChanges {

  @Input() policy: Policy;
  @Input() item: Collation;
  @Input() vap: PolicyBenefitsAdded;
  @Input() entity = '';
  @Input() source = '';
  @Input() new_session_id: any;
  @Input() frequency_id = 3;
  @Input() isEditPolicyPage = false;
  @Output() getNewDataEdit = new EventEmitter<boolean>();
  //@Output() getNewData = new EventEmitter<boolean>();
  @Output() getNewData = new EventEmitter<boolean | [boolean, any?]>();
  @Output() pauseModal = new EventEmitter<boolean>();
@ViewChild('cancel-policy-summary-modal') cancelModal!: ElementRef;

  cancelDateSelection = '';
  cancelDate = '';
  responsetext = '';
  cancelDateValue: Date;
  refund: CalcPremDiffCollation;
  accounting: any;
  spinner = false;
  entities = Entity;
  user: any;
  cancelDateSelectionEnum = CancelDateSelection;
  cancelSelectionDateModalButtonEnabled = false;
  reasonProvided = false;
  startMinDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
  options: any = [];
  reason = {id: 0, text: ""};
  constructor(
    private policyService: PolicyService,
    private questionService: GlobalQuestionService,
    private userStore: UserStore,
    public datePipe: DatePipe,
    private ngZone: NgZone,
    public router: Router) {
      this.user = this.userStore.getValue();
  }

  ngOnInit(): void {
    
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    const parameters = new Map<string, string>();
    //parameters.set('new_session_id', this.session_details.session_id);
    this.questionService.runCommandNew('[dbo].[getCancellationReasons]', parameters).subscribe((reasons) => {
      
      if (this.user?.broker_id > 0 || this.user.console_access){
        reasons.forEach(r => {
            this.options.push({value:r?.cancellation_reason_id, label: r?.cancellation_reason})
        });
      }
      else{
        reasons.forEach(r => {
          if (r?.show_client === 1){
            this.options.push({value:r?.cancellation_reason_id, label: r?.cancellation_reason})
          }
        });
      }

    })
    initModalHandler();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.user.console_access || this.user.broker_id > 0) { // console access or broker can back date
      this.startMinDate = new Date(1900, 0, 0)
    }
    if (changes?.policy?.currentValue !== changes?.policy?.previousValue) {
      this.policy = changes?.policy?.currentValue;
      if (this.accounting) {
        this.accounting.settings.currency.symbol = `${this.policy?.currency ? this.policy?.currency : 'R'} `;
      }
    }
  }
  ngAfterViewInit() {
    $('#cancel-policy-summary-modal').on('hidden.bs.modal', () => {
      //Call a method on the component to emit the event
      try {
        this.isEditPolicyPage = JSON.parse(localStorage.getItem('isEditPolicyPage'));
      }
      catch { }
      if (this.isEditPolicyPage) {
        this.getNewDataEdit.emit(true);
        localStorage.removeItem('isEditPolicyPage')
      }

    });
  }
  showCancelModal(entity: Entity, item?: any): void {
    this.entity = entity;
    if (item) {
      if (entity === Entity.Item) {
        this.item = item;
      } else if (entity === Entity.Vap) {
        this.vap = item;
      }
    }
    
    // Lets store this in localStrorage in case Jquery destroys it;
    if (this.entity != '') localStorage.setItem('entity', JSON.stringify(this.entity));
    if (this.vap) localStorage.setItem('vap', JSON.stringify(this.vap));
    if (this.item) localStorage.setItem('item', JSON.stringify(this.item));
    if (this.isEditPolicyPage) localStorage.setItem('isEditPolicyPage', JSON.stringify(this.isEditPolicyPage));
    $('#cancel-policy-date-modal').modal('show');
  }

  onDatePickerChange(value: any): void {
    this.cancelDate = value;
    this.cancelDateValue = new Date(this.cancelDate);

    this.cancelSelectionDateModalButtonEnabled = !!this.cancelDate;
  }

  onDateSelectionChange(): void {
    if (this.cancelDateSelection === CancelDateSelection.Today) {
      const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
      this.cancelDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    } else if (this.cancelDateSelection === CancelDateSelection.EndOfMonth) {
      const today = new Date();
      this.cancelDate = this.datePipe.transform(new Date(today.getFullYear(), today.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    if (this.cancelDate) {
      this.cancelSelectionDateModalButtonEnabled = true;
      this.cancelDateValue = new Date(this.cancelDate);
    } else {
      this.cancelSelectionDateModalButtonEnabled = false;
    }
  }

  populateProperties(): void {
    this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    switch (this.entity) {
      case Entity.Policy:
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '4');
        parameters.set('class_id', '0');
        parameters.set('item_id', '0');
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
            try{
              this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
              this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
              $('#cancel-policy-date-modal').modal('hide');
              $('#cancel-policy-date-modal').on('hidden.bs.modal', () => {
                $('#cancel-policy-summary-modal').modal('show');
              });
            }
            catch{
              Alert("Technical Error experienced");
            }
            
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });
        break;
      case Entity.Item:
       // const parameters = new Map<string, string>();
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '4');
        parameters.set('class_id', this.item?.class_id.toString());
        parameters.set('item_id', this.item?.session_item_id.toString());
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            $('#cancel-policy-date-modal').modal('hide');
            $('#cancel-policy-date-modal').on('hidden.bs.modal', () => {
              $('#cancel-policy-summary-modal').modal('show');
            });
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });
        break;
      case Entity.Vap:
        let vap_id = this.vap?.vaps_id ? this.vap?.vaps_id : this.vap?.product_vaps_id ? this.vap?.product_vaps_id : 0;
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '4');
        parameters.set('class_id', this.vap?.class_id.toString());
        parameters.set('item_id', this.vap?.session_item_id.toString());
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('vaps_id', vap_id.toString());
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            $('#cancel-policy-date-modal').modal('hide');
            $('#cancel-policy-date-modal').on('hidden.bs.modal', () => {
              $('#cancel-policy-summary-modal').modal('show');
            });
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });
        break;
    }
    
  }

  changeToCancelled(): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Item || this.entity === Entity.Vap) {
       try {
        this.isEditPolicyPage = JSON.parse(localStorage.getItem('isEditPolicyPage'));
      }
      catch { }
      if (this.isEditPolicyPage) {
          $('#cancel-policy-summary-modal').modal('hide'); 
      } else {
        const parameters = new Map<string, string>();
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '1');
        parameters.set('class_id', '0');
        parameters.set('item_id', '0');
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(result => {
            this.policyService.submitPolicyUpdates(this.policy?.session_id)
              .subscribe((response) => {
                $('#cancel-policy-summary-modal').modal('hide');
                $('#cancel-policy-date-modal').modal('hide');
                this.getNewData.emit([true,response]);
                this.questionService.spinner(false);
                if (response[0].log_id) {
                  Alert("Technical Error experienced");
                }
                if (response[0].status) {
                  Alert(response[0]?.status);
                }
              }, err => {
                this.questionService.spinner(false);
                Alert("Technical Error experienced");
              });
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });

      }
    } else if (this.entity === Entity.Policy) {
      this.policyService.submitPolicyUpdates(this.policy?.session_id)
        .subscribe(( response ) => {
          console.log(response[0]);
          $('#cancel-policy-summary-modal').modal('hide');
          $('#cancel-policy-date-modal').modal('hide');
          this.getNewData.emit(true);
          this.questionService.spinner(false);
          let url = localStorage.getItem('previous-document-page');
          if (response[0].log_id) {
            Alert("Technical Error experienced");
          }
          if (response[0].status) {
            Alert(response[0]?.status);
          }
          this.router.navigate([url]);
        }, err => {
          this.questionService.spinner(false);
          Alert("Technical Error experienced");
        });
    }
  }

  removeAction(status_id: number): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Policy) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, 0, '0', 0, status_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Item) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.item?.class_id, this.item?.session_item_id, 0, status_id)
        .subscribe(() => {
          let today: any;
          today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Vap) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.vap?.class_id, this.vap?.session_item_id, 0, status_id, this.vap?.vaps_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    }
    $('#cancel-policy-date-modal').modal('hide');
    
  }

  closeCancelPolicyAlertModal(): void {
    $('#cancel-policy-alert-modal').modal('hide');
  }

  closeCancelPolicyDateModal(): void {
    $('#cancel-policy-date-modal').modal('hide');
  }

  closeCancelPolicySummaryModal(): void {
    $('#cancel-policy-summary-modal').modal('hide');
  }
  getReasonID(event: any): void{
    this.reason.id = +event;
    
    if (this.reason?.id > 0 && this.reason?.text !== ""){
      this.reasonProvided = true;
    }
    else{
      this.reasonProvided = false;
    }
  }
  getReasonText(): void{
    
    this.reason.text = this.responsetext;
    if (this.reason?.id > 0 && this.reason?.text !== ""){
      this.reasonProvided = true;
    }
    else{
      this.reasonProvided = false;
    }
  }
  saveCancellationRequest(): void {
    
    if (this.entity == '' || !this.vap || !this.item) { //We have a problems, lets fetch from localStorage
      try {
        this.entity = JSON.parse(localStorage.getItem('entity'));
        this.vap = JSON.parse(localStorage.getItem('vap'));
        this.item = JSON.parse(localStorage.getItem('item'));
      }
      catch { }
    }
    //Clean up
    localStorage.removeItem('entity');
    localStorage.removeItem('vap');
    localStorage.removeItem('item');
    if (this.user?.console_access || this.user?.broker_id > 0) {
      const parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy.policy_id.toString());
      parameters.set('date_cancellation', this.cancelDate?.toString());
      parameters.set('cancellation_reason_id', this.reason?.id.toString());
      parameters.set('send_email', '0');
      parameters.set('user_id', this.user?.person_id.toString());
      parameters.set('description', this.reason?.text);
      this.questionService.runCommandNew('[dbo].[saveCancellationRequest]', parameters).subscribe((response) => {
        this.populateProperties();
      })
    }
    else if (this.entity == Entity.Item || this.entity == Entity.Vap) {
      const parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy.policy_id.toString());
      parameters.set('date_cancellation', this.cancelDate?.toString());
      parameters.set('cancellation_reason_id', this.reason?.id.toString());
      parameters.set('send_email', '0');
      parameters.set('user_id', this.user?.person_id.toString());
      parameters.set('description', this.reason?.text);
      this.questionService.runCommandNew('[dbo].[saveCancellationRequest]', parameters).subscribe((response) => {
        this.populateProperties();
      })

    }
    else {
      const parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy.policy_id.toString());
      parameters.set('date_cancellation', this.cancelDate?.toString());
      parameters.set('cancellation_reason_id', this.reason?.id.toString());
      parameters.set('description', this.reason?.text);
      parameters.set('user_id', this.user?.person_id.toString());
      this.questionService.runCommandNew('[dbo].[saveCancellationRequest]', parameters).subscribe((response) => {
        Alert(response[0]?.response);
        $('#cancel-policy-date-modal').modal('hide');

      })
    }
  }
  parseJSON(obj: string): any {
    try {
      return JSON.parse(obj)[0];
    } catch (e) {
      return JSON.parse(obj);
    }
  }

}
